import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ComparisonFeatureItem } from '@as/cotopaxi';
import { InfoIcon } from '@yonderland/andes-icons';
import { Icon, Tooltip } from '@yonderland/andes-react';
import { useMemo, useState, useEffect } from 'react';
import { GLOSSARY_KEY } from '../../../constants/GeneralConstants';
export const CompareFeatureItem = ({ feature, isGlossaryLoaded, shouldInitGlossaryTooltip, setSwiperInstance, }) => {
    const [targetElement, setTargetElement] = useState(null);
    const glossaryId = `feature-item-${feature.title}`;
    const getGlossaryItem = (title, isLoaded) => { var _a; return isLoaded ? (_a = window[GLOSSARY_KEY]) === null || _a === void 0 ? void 0 : _a.find((glossary) => glossary.triggers.includes(title)) : undefined; };
    const glossaryItem = useMemo(() => getGlossaryItem(feature.title, isGlossaryLoaded), [feature, isGlossaryLoaded, shouldInitGlossaryTooltip]);
    const _setSwiperInstance = (swiper) => setSwiperInstance(swiper, feature.attribute);
    // Find the target element after render
    useEffect(() => {
        if (glossaryItem && shouldInitGlossaryTooltip) {
            const element = document.getElementById(glossaryId);
            if (element) {
                setTargetElement(element);
            }
        }
    }, [glossaryItem, shouldInitGlossaryTooltip, glossaryId]);
    return (_jsxs(_Fragment, { children: [_jsx(ComparisonFeatureItem, { title: feature.title, values: feature.valuesByProducts, glossaryId: glossaryId, showGlossary: !!glossaryItem, setSwiperInstance: _setSwiperInstance }), glossaryItem && targetElement && (_jsx(Tooltip, { targetElement: targetElement, title: glossaryItem.title, text: glossaryItem.description, placement: "bottom", children: _jsx(Icon, { source: InfoIcon, size: "sm" }) }))] }));
};
